import { type Plugin, ref } from 'vue';
import { createI18n } from 'vue-i18n';

import sharedDeDE from '../translations/de-DE.json';
import sharedEnUS from '../translations/en-US.json';
import sharedFrFR from '../translations/fr-FR.json';
import { defaultOptions, type SharedPluginOptions } from './sharedPluginOptions';

export const i18n = ref<ReturnType<typeof createI18n>>();

export const setupI18n: (options?: Partial<SharedPluginOptions>) => Plugin = (options?: Partial<SharedPluginOptions>) => {
	i18n.value = createI18n({
		legacy: false,
		locale: options?.locale ?? defaultOptions.value.locale,
		fallbackLocale: options?.fallbackLocale ?? defaultOptions.value.fallbackLocale,
		messages: {
			'de-DE': { ...options?.message?.['de-DE'] ?? {}, ...sharedDeDE },
			'en-US': { ...options?.message?.['en-US'] ?? {}, ...sharedEnUS },
			'fr-FR': { ...options?.message?.['fr-FR'] ?? {}, ...sharedFrFR }
		}
	});

	return i18n.value;
};